var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M22.4,2H5.6A3.6,3.6,0,0,0,2,5.6V7a3.6,3.6,0,0,0,.3,1.44v.072a3.372,3.372,0,0,0,.708,1.032L10.4,16.892V24.8a1.194,1.194,0,0,0,1.74,1.068l4.8-2.4A1.2,1.2,0,0,0,17.6,22.4V16.892l7.344-7.344a3.372,3.372,0,0,0,.708-1.032V8.444A3.6,3.6,0,0,0,26,7V5.6A3.6,3.6,0,0,0,22.4,2Zm1.2,4.8s-.028,2.4-1.2,2.4-15.282.2-16.8,0S4.4,6.8,4.4,6.8C11.271,6.783,14.758,6.709,23.6,6.8Z",
    transform: "translate(-2 -2)",
    fill: "#434db8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterFilled);
export default __webpack_public_path__ + "static/media/FilterFilled.b04cf35cd7de29371fa39bd881d5cc51.svg";
export { ForwardRef as ReactComponent };